import { render, staticRenderFns } from "./YKIssuedFlow.vue?vue&type=template&id=0711b20c&scoped=true&"
import script from "./YKIssuedFlow.vue?vue&type=script&lang=js&"
export * from "./YKIssuedFlow.vue?vue&type=script&lang=js&"
import style0 from "./YKIssuedFlow.vue?vue&type=style&index=0&id=0711b20c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711b20c",
  null
  
)

export default component.exports